function i(i){return(n,t,r,o)=>{const{target:e,originX:g,originY:a}=t,s=e.getRelativeCenterPoint(),u=e.translateToOriginPoint(s,g,a),P=i(n,t,r,o);return e.setPositionByOrigin(u,t.originX,t.originY),P}}export{i as wrapWithFixedAnchor};
//# sourceMappingURL=wrapWithFixedAnchor.min.mjs.map
